/**
 * Shared helpers for the country/language pickers used across every Weekly Insights
 * page (Trending, New Release, Top Apps, Top Discounts, Pre-Orders). Each page used to
 * define its own copy of these — identical except for the odd typo — so a change to
 * one (e.g. adding a locale label) never made it to the others.
 */

/** Maps a raw locale code from the API (e.g. `espanol`) to a display label
 *  (`Español`). Unknown locales fall back to a title-cased version of the code. */
export function prettifyLocaleLabel(locale) {
  const map = {
    english: 'English',
    espanol: 'Español',
    francais: 'Français',
    deutsch: 'Deutsch',
    italiano: 'Italiano',
    nihongo: '日本語',
    hangugeo: '한국어',
    zhongwen: '中文',
    nederlands: 'Nederlands',
    polski: 'Polski',
    portugues: 'Português',
    dansk: 'Dansk',
    suomi: 'Suomi',
    norsk_bokmal: 'Norsk',
    svenska: 'Svenska',
  }
  return map[locale] || (locale || '').replace(/_/g, ' ').replace(/(^|\s)\S/g, (s) => s.toUpperCase())
}

/** The `react-select` option list of locales available for a given country code,
 *  derived from the `/countries/` API response (`countriesList`). */
export function getLocalesForCountry(countriesList, countryCode) {
  if (!countriesList || countriesList.length === 0) return []
  const country = countriesList.find((c) => c.code === countryCode)
  if (!country || !Array.isArray(country.locales)) return []
  return country.locales.map((locale) => ({ value: locale, label: prettifyLocaleLabel(locale) }))
}
